module.exports = __webpack_public_path__ + "img/engineering.16a7d652.jpg";